import { z } from 'zod';

export const HealthResponseSchema = z
  .object({
    status: z.enum(['ok', 'degraded']),
    db: z.enum(['up', 'down']),
    redis: z.enum(['up', 'down']),
  })
  .refine(
    (data) => {
      if (data.status === 'ok') return data.db === 'up' && data.redis === 'up';
      return data.db === 'down' || data.redis === 'down';
    },
    { message: 'status must be "ok" only when all services are "up"' },
  );

export type HealthResponse = z.infer<typeof HealthResponseSchema>;
